import { saveDataInStorage } from '../../utils/Storage/storageFunctions';

export default function saveUserData(data) {
  saveDataInStorage(data, 'vacanted');
}
